export enum BlockType {
    BLOCK_IMAGE = "BLOCK_IMAGE",
    BLOCK_TEXT = "BLOCK_TEXT",
    BLOCK_BUTTON = "BLOCK_BUTTON",
    BLOCK_SPACER = "BLOCK_SPACER",
    BLOCK_VIDEO = "BLOCK_VIDEO",
    BLOCK_SOCIAL = "BLOCK_SOCIAL",
    BLOCK_BANNER = "BLOCK_BANNER",
    BLOCK_TIMER = "BLOCK_TIMER",
    BLOCK_MENU = "BLOCK_MENU",
    BLOCK_MENU_ITEM = "BLOCK_MENU_ITEM",
    BLOCK_HTML = "BLOCK_HTML",
    BLOCK_AMP_CAROUSEL = "BLOCK_AMP_CAROUSEL",
    BLOCK_AMP_ACCORDION = "BLOCK_AMP_ACCORDION",
    BLOCK_AMP_FORM = "BLOCK_AMP_FORM",
    CONTAINER = "CONTAINER",
    FORM_CONTAINER = "FORM_CONTAINER",
    STRUCTURE = "STRUCTURE",
    STRIPE = "STRIPE",
    EMPTY_CONTAINER = "EMPTY_CONTAINER",
    CUSTOM_BLOCK_LINK = "CUSTOM_BLOCK_LINK",
    CUSTOM_BLOCK_IMAGE = "CUSTOM_BLOCK_IMAGE",
    CUSTOM_BLOCK_TEXT = "CUSTOM_BLOCK_TEXT",
}
